"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUY_UPGRADE_SUCCESS = exports.RESUME_SUBSCRIPTION_SUCCESS = exports.CANCEL_SUBSCRIPTION_SUCCESS = exports.BUY_SUCCESS = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.hasSubscriptionPlans = hasSubscriptionPlans;
exports.cancelSubscription = cancelSubscription;
exports.resumeSubscription = resumeSubscription;
exports.buySubscription = buySubscription;
exports.updateSubscriptionPaymentMethod = updateSubscriptionPaymentMethod;
exports.getSubscriptionPlans = getSubscriptionPlans;
exports.getUpgrade = getUpgrade;
exports.buyUpgrade = buyUpgrade;
exports.setChosenPlan = setChosenPlan;
exports.setProjectDetails = setProjectDetails;

var _utils = require("../../utils");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _payments = require("./payments");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUY = "ms/subscriptions/buy";
var BUY_SUCCESS = exports.BUY_SUCCESS = "ms/subscriptions/buy_success";
var BUY_FAIL = "ms/subscriptions/buy_fail";

var GET_PLANS = "ms/subscriptions/get_plans";
var GET_PLANS_SUCCESS = "ms/subscriptions/get_plans_success";
var GET_PLANS_FAIL = "ms/subscriptions/get_plans_fail";

var UPDATE_PAYMENT_METHOD = "ms/subscriptions/update_payment_method";
var UPDATE_PAYMENT_METHOD_SUCCESS = "ms/subscriptions/update_payment_method_success";
var UPDATE_PAYMENT_METHOD_FAIL = "ms/subscriptions/update_payment_method_fail";

var CANCEL_SUBSCRIPTION = "ms/subscriptions/cancel_subscription";
var CANCEL_SUBSCRIPTION_SUCCESS = exports.CANCEL_SUBSCRIPTION_SUCCESS = "ms/subscriptions/cancel_subscription_success";
var CANCEL_SUBSCRIPTION_FAIL = "ms/subscriptions/cancel_subscription_fail";

var RESUME_SUBSCRIPTION = "ms/subscriptions/resume_subscription";
var RESUME_SUBSCRIPTION_SUCCESS = exports.RESUME_SUBSCRIPTION_SUCCESS = "ms/subscriptions/resume_subscription_success";
var RESUME_SUBSCRIPTION_FAIL = "ms/subscriptions/resume_subscription_fail";

var GET_UPGRADE = "ms/subscriptions/get_upgrade";
var GET_UPGRADE_SUCCESS = "ms/subscriptions/get_upgrade_success";
var GET_UPGRADE_FAIL = "ms/subscriptions/get_upgrade_fail";

var BUY_UPGRADE = "ms/subscriptions/buy_upgrade";
var BUY_UPGRADE_SUCCESS = exports.BUY_UPGRADE_SUCCESS = "ms/subscriptions/buy_upgrade_success";
var BUY_UPGRADE_FAIL = "ms/subscriptions/buy_upgrade_fail";

var CHOSEN_PLAN = "ms/subscriptions/set_chosen_plan";
var SET_PROJECT_DETAILS = "ms/subscriptions/set_project_details";

var initialState = {
  buying: false,
  bought: false,
  buyError: false,
  chosenPlan: null,

  plans: null,
  subPlans: null,
  gettingPlans: false,
  gettingPlansError: null,

  plansDecorated: [{
    order: 1,
    name: "Unreal Engine",
    desc: "Free for use with Unreal Engine only.",
    subDesc: "* If you have a Content License, just sign in with your Epic Games account to get unlimited free access to the Megascans library.",
    amount: "FREE",
    points: 90,
    indefinitePointsUsage: true,
    accessResolution: 8192,
    downloadLimit: 15,
    billingCycle: 1,
    isStudio: false,
    multiSeat: true,
    minSeats: 1,
    maxSeats: 50,
    allowPublicPayment: true,
    upgradePoint: 100,
    isEligibleForDrops: true,
    monthlyDropsCount: 5,
    accessResolutionName: "8K",
    billing: "monthly",
    exrAccess: "displacement",
    license: "unreal",
    type: "unreal",
    refillPricePointMap: [{
      price: 15,
      points: 20,
      id: "addon-personal-1"
    }, {
      price: 19,
      points: 40,
      id: "addon-personal-2"
    }, {
      price: 29,
      points: 60,
      id: "addon-personal-3"
    }],
    marketingPoints: [{
      logo: "",
      check: "Unlimited Seats"
    }, {
      logo: "",
      check: "8K Resolution"
    }, {
      logo: "",
      check: "Unlimited Access *"
    }]
  }, {
    order: 2,
    name: "Personal",
    desc: "Up to $100K funding or yearly rev.",
    subDesc: "* 45 Surfaces, or 22 3D Models, or 90 other asset types. Additional points can be purchased at any time.",
    amount: 19,
    points: 90,
    indefinitePointsUsage: true,
    accessResolution: 8192,
    downloadLimit: 15,
    billingCycle: 1,
    isStudio: false,
    multiSeat: true,
    minSeats: 1,
    maxSeats: 1,
    allowPublicPayment: true,
    upgradePoint: 100,
    isEligibleForDrops: true,
    monthlyDropsCount: 5,
    accessResolutionName: "8K",
    billing: "monthly",
    exrAccess: "displacement",
    license: "freelancer",
    type: "personal-monthly",
    refillPricePointMap: [{
      price: 15,
      points: 20,
      id: "addon-indie-1"
    }, {
      price: 19,
      points: 40,
      id: "addon-indie-2"
    }, {
      price: 29,
      points: 60,
      id: "addon-indie-3"
    }],
    marketingPoints: [{
      logo: "",
      check: "Single Seat"
    }, {
      logo: "",
      check: "8K Resolution"
    }, {
      logo: "",
      check: "90 Points / month *"
    }]
  }, {
    order: 3,
    name: "Indie",
    desc: "Up to $2M funding or yearly rev.",
    subDesc: "* 45 Surfaces, or 22 3D Models, or 90 other asset types. Additional points can be purchased at any time.",
    amount: 199,
    points: 90,
    indefinitePointsUsage: true,
    accessResolution: 8192,
    downloadLimit: 15,
    billingCycle: 1,
    isStudio: false,
    multiSeat: true,
    minSeats: 1,
    maxSeats: 10,
    allowPublicPayment: true,
    upgradePoint: 100,
    isEligibleForDrops: true,
    monthlyDropsCount: 5,
    accessResolutionName: "8K",
    billing: "monthly",
    exrAccess: "displacement",
    license: "indie",
    type: "indie-monthly",
    refillPricePointMap: [{
      price: 15,
      points: 20,
      id: "addon-pro-1"
    }, {
      price: 19,
      points: 40,
      id: "addon-pro-2"
    }, {
      price: 29,
      points: 60,
      id: "addon-pro-3"
    }],
    marketingPoints: [{
      logo: "",
      check: "Unlimited Seats"
    }, {
      logo: "",
      check: "8K Resolution"
    }, {
      logo: "",
      check: "90 Points / month *"
    }]
  }, {
    type: "studio",
    license: "studio",
    name: "Studio",
    desc: "Unlimited creativity with Megascans for studios with over $2M in funding or yearly revenue. Customized solutions for large productions to help your projects succeed.",
    contactUs: true,
    contactUsDescription: "Customized solutions to help your project succeed."
  }],
  plansDecoratedAnual: [],
  educationalPlan: [],
  cancelling: false,
  cancelled: false,
  cancelError: null,

  resuming: false,
  resumed: false,
  resumeError: null,

  upgrades: { loading: true }
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case BUY:
    case BUY_UPGRADE:
      return (0, _extends3.default)({}, state, {
        buying: true
      });

    case BUY_SUCCESS:
    case BUY_UPGRADE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        buying: false,
        bought: true
      });

    case BUY_FAIL:
    case BUY_UPGRADE_FAIL:
      return (0, _extends3.default)({}, state, {
        buying: false,
        buyError: action.error
      });

    case GET_PLANS:
      return (0, _extends3.default)({}, state, {
        gettingPlans: true,
        gettingPlansError: null
      });

    case GET_PLANS_SUCCESS:
      var filterAndDecoratePlans = _ramda2.default.compose(_ramda2.default.map(_ramda2.default.converge(_ramda2.default.merge, [_ramda2.default.identity, _ramda2.default.compose(_ramda2.default.find(_ramda2.default.__, _ramda2.default.prop("plansDecorated", state)), _ramda2.default.propEq("license"), _ramda2.default.prop("license"))])), _ramda2.default.append(_ramda2.default.objOf("license", "studio")), _ramda2.default.map(_ramda2.default.head), _ramda2.default.values, _ramda2.default.groupBy(_ramda2.default.prop("license")), _ramda2.default.filter(_ramda2.default.complement(_ramda2.default.propEq("isStudio", true))));
      var plansDecorated = state.plansDecorated; //filterAndDecoratePlans(action.result);

      //Removing Educational Plans and studio.
      plansDecorated = _ramda2.default.reject(function (n) {
        return n.license === "educational"; //|| n.license === "studio";
      }, plansDecorated);

      plansDecorated = _ramda2.default.sortWith([_ramda2.default.ascend(_ramda2.default.prop("order"))])(plansDecorated);

      var plansDecoratedAnual = [];
      for (var i = 0; i < plansDecorated.length; i++) {
        var monthlyPlan = plansDecorated[i];
        for (var j = 0; j < action.result.length; j++) {
          var plan = action.result[j];
          if (plan.type == monthlyPlan.type + "-annual") {
            var yearlyPlan = (0, _extends3.default)({}, monthlyPlan);
            for (var key in plan) {
              yearlyPlan[key] = plan[key];
            }
            plansDecoratedAnual.push(yearlyPlan);
            break;
          }
        }
      }
      //plansDecoratedAnual.push(plansDecorated[plansDecorated.length-1]);

      var plans = JSON.parse((0, _stringify2.default)(action.result));

      for (var i = 0; i < plans.length; i++) {
        if (plans[i].type === "personal-4K" || action.result[i].type === "personal-4K-annual") {
          plans[i].accessResolution = 4097;
        } else if (plans[i].type === "archviz-8K-375") {
          plans[i].accessResolution = 8193;
        }
      }
      for (var i = 0; i < plans.length; i++) {
        for (var j = 0; j < plans.length; j++) {
          if (plans[i].type === "personal-4K" && plans[j].type === "personal-4K-annual") {
            plans[j].discount = plans[i].amount * 12 - plans[j].amount;
          }
          if (plans[i].type === "personal-8K" && plans[j].type === "personal-8K-annual") {
            plans[j].discount = plans[i].amount * 12 - plans[j].amount;
          }
        }
      }
      plansDecoratedAnual = plansDecorated;

      // Get Educational Decorated Plans
      // let educationalPlan = R.filter((n) =>{
      //   return n.license==='educational' && n.billingCycle ===12;
      // }, plans);
      //
      // let archVizPlan = R.filter((n) =>{
      //   return n.license==='archviz' && n.points === 250;
      // }, plans);
      //
      // let businessPlan = R.filter((n) =>{
      //   return n.license==='indie' && n.points === 250;
      // }, plans);
      //
      // educationalPlan[0].desc = "5x more Megascans assets, plus everything in Free."
      // educationalPlan[0].subscribeHandleClick = true;
      // educationalPlan[0].marketingPoints = [
      //   {
      //     logo:'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png',
      //     desc:'Megascans&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;2000 premium assets',
      //   },
      //   {
      //     logo:'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/megascans_icon_2048_preview.png',
      //     desc:'4K max resolution',
      //   },
      //   {
      //     logo:'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/bridge_icon_2048.png',
      //     desc:'Quixel Bridge',
      //   },
      //   {
      //     logo:'https://d3uwib8iif8w1p.cloudfront.net/quixel/icons/mixer_icon_2048_preview.png',
      //     desc:'Quixel Mixer',
      //   },
      // ];
      var educationalPlan = [{
        license: "studio",
        name: "Education Free",
        desc: "Hundreds of Megascans assets.",
        subDesc: "Choose a 3 month, 6 month, or 1 year renewable license.",
        contactUs: true,
        marketingPoints: [{
          logo: "",
          check: "Megascans&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;400 premium assets"
        }, {
          logo: "",
          check: "4K max resolution"
        }, {
          logo: "",
          check: "Quixel Bridge"
        }, {
          logo: "",
          check: "Quixel Mixer"
        }]
      }];
      //
      // educationalPlan=R.reverse(educationalPlan);

      return (0, _extends3.default)({}, state, {
        gettingPlans: false,
        plans: action.result,
        subPlans: plans,
        plansDecorated: plansDecorated,
        plansDecoratedAnual: plansDecoratedAnual,
        educationalPlan: educationalPlan
        // archVizPlan,
        // businessPlan
      });

    case GET_PLANS_FAIL:
      return (0, _extends3.default)({}, state, {
        gettingPlans: false,
        gettingPlansError: action.error
      });

    case CANCEL_SUBSCRIPTION:
      return (0, _extends3.default)({}, state, {
        cancelling: true,
        cancelled: false,
        cancelError: null
      });

    case CANCEL_SUBSCRIPTION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        cancelling: false,
        cancelled: true,
        cancelError: null
      });

    case CANCEL_SUBSCRIPTION_FAIL:
      return (0, _extends3.default)({}, state, {
        cancelling: false,
        cancelled: false,
        cancelError: action.error
      });

    case RESUME_SUBSCRIPTION:
      return (0, _extends3.default)({}, state, {
        resuming: true,
        resumed: false,
        resumeError: null
      });

    case RESUME_SUBSCRIPTION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        resuming: false,
        resumed: true,
        resumeError: null
      });

    case RESUME_SUBSCRIPTION_FAIL:
      return (0, _extends3.default)({}, state, {
        resuming: false,
        resumed: false,
        resumeError: action.error
      });

    case GET_UPGRADE:
      return (0, _extends3.default)({}, state, {
        upgrades: {
          from: action.meta.from,
          to: action.meta.to,
          loading: true
        }
      });

    case GET_UPGRADE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        upgrades: (0, _extends3.default)({}, state.upgrades, action.result, {
          loading: false
        })
      });

    case CHOSEN_PLAN:
      return (0, _extends3.default)({}, state, {
        chosenPlan: action.meta
      });

    case SET_PROJECT_DETAILS:
      return (0, _extends3.default)({}, state, {
        projectNameForSubscription: action.meta.projectName,
        projectDetailsForSubscription: action.meta.projectDetails,
        seatsForSubscription: action.meta.seats
      });

    case _payments.PAYMENT_INIT:
      return (0, _extends3.default)({}, _ramda2.default.omit(["chosenPlan", "projectNameForSubscription", "projectDetailsForSubscription", "seatsForSubscription"], state));

    default:
      return state;
  }
}

// Helper functions
function hasSubscriptionPlans(state) {
  return state.subscriptions.plans && state.subscriptions.plans.length;
}

// Action creators
function cancelSubscription(reason) {
  return {
    types: [CANCEL_SUBSCRIPTION, CANCEL_SUBSCRIPTION_SUCCESS, CANCEL_SUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.post("v1/payments/plans/autorenew/off", {
        data: {
          reason: reason
        }
      }).then(function (res) {
        return res;
      });
    }
  };
}

function resumeSubscription() {
  return {
    types: [RESUME_SUBSCRIPTION, RESUME_SUBSCRIPTION_SUCCESS, RESUME_SUBSCRIPTION_FAIL],
    promise: function promise(client) {
      return client.post("v1/payments/plans/autorenew/on").then(function (res) {
        return res;
      });
    }
  };
}

function buySubscription(_ref) {
  var planId = _ref.planId,
      multiSeat = _ref.multiSeat,
      seats = _ref.seats,
      projectName = _ref.projectName,
      projectDetails = _ref.projectDetails,
      promocode = _ref.promocode,
      signedPromocodeInstance = _ref.signedPromocodeInstance;

  return function (_ref2) {
    var amount = _ref2.amount,
        threeDNonce = _ref2.threeDNonce,
        token = _ref2.token;

    return function (dispatch, getState) {
      var state = getState();
      var user = state.user;

      var isSwitchingPlans = (0, _utils.isActiveSubscriberNoTrial)(user);

      var endpointForSwitchOrBuy = isSwitchingPlans ? "/v1/payments/plans/switch" : "/v1/payments/plans";

      return dispatch({
        types: [BUY, BUY_SUCCESS, BUY_FAIL],
        promise: function promise(client) {
          return client.post(endpointForSwitchOrBuy, {
            data: (0, _extends3.default)({
              planId: planId,
              amount: amount,
              projectName: projectName,
              projectDetails: projectDetails
            }, multiSeat && {
              numberOfSeats: seats
            }, promocode && {
              promocode: promocode,
              signedPromocodeInstance: signedPromocodeInstance
            }, !isSwitchingPlans && { paymentMethodToken: token }, {

              paymentMethod3DNonce: threeDNonce
            })
          });
        }
      });
    };
  };
}

function updateSubscriptionPaymentMethod(_ref3) {
  var token = _ref3.token,
      threeDNonce = _ref3.threeDNonce;

  return {
    types: [UPDATE_PAYMENT_METHOD, UPDATE_PAYMENT_METHOD_SUCCESS, UPDATE_PAYMENT_METHOD_FAIL],
    promise: function promise(client) {
      return client.post("v1/payments/updatePaymentMethodReferences", {
        data: {
          paymentMethodToken: token,
          paymentMethod3DNonce: threeDNonce
        }
      });
    }
  };
}

function getSubscriptionPlans() {
  return {
    types: [GET_PLANS, GET_PLANS_SUCCESS, GET_PLANS_FAIL],
    promise: function promise(client) {
      return client.get("v1/payments/plans").then(function (plans) {
        return _underscore2.default.pairs(plans).map(function (p) {
          return (0, _extends3.default)({}, p[1], {
            planType: p[0].split("-")[0],
            type: p[0]
          });
        });
      });
    }
  };
}

function getUpgrade(from, to) {
  return function (dispatch, getState) {
    var _getState$subscriptio = getState().subscriptions.upgrades,
        stateFrom = _getState$subscriptio.from,
        stateTo = _getState$subscriptio.to;


    if (stateFrom == from && stateTo == to) return _bluebird2.default.resolve();

    return dispatch({
      types: [GET_UPGRADE, GET_UPGRADE_SUCCESS, GET_UPGRADE_FAIL],
      meta: { from: from, to: to },
      promise: function promise(client) {
        return client.get("/v1/payments/upgrade?planId=" + to);
      }
    });
  };
}

function buyUpgrade(_ref4) {
  var planId = _ref4.planId,
      amount = _ref4.amount,
      token = _ref4.token;

  return {
    types: [BUY_UPGRADE, BUY_UPGRADE_SUCCESS, BUY_UPGRADE_FAIL],
    promise: function promise(client) {
      return client.post("v1/payments/upgrade", {
        data: {
          planId: planId,
          paymentMethodToken: paymentMethodToken,
          amount: amount
        }
      });
    }
  };
}

function setChosenPlan(plan) {
  return function (dispatch) {
    return dispatch({
      type: CHOSEN_PLAN,
      meta: plan
    });
  };
}

function setProjectDetails(_ref5) {
  var projectName = _ref5.projectName,
      projectDetails = _ref5.projectDetails,
      seats = _ref5.seats;

  return function (dispatch) {
    return dispatch({
      type: SET_PROJECT_DETAILS,
      meta: { projectName: projectName, projectDetails: projectDetails, seats: seats }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/subscriptions.js
// module id = 69
// module chunks = 0